import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import LoginEmail from "../login/login-email";
import LoginOtp from "../login/login-otp";
const NavTabs = () => {
    const [activeTab, setActiveTab] = useState('1');
    return (
        <div className="ebw-entry__rgt-tabs h-100">
            <Nav tabs className="ebw-entry__nav d-flex flex-row justify-content-start">
                <NavItem className="ebw-entry__nav-item">
                    <NavLink
                        className={activeTab == '1' ? 'active' : ''}
                        onClick={() => setActiveTab('1')}
                    >
                        Login using email
                    </NavLink>
                </NavItem>

                <NavItem className="ebw-entry__nav-item">
                    <NavLink
                        className={activeTab == '2' ? 'active' : ''}
                        onClick={() => setActiveTab('2')}
                    >
                        Login using OTP
                    </NavLink>
                </NavItem>
            </Nav>

            <TabContent activeTab={activeTab} className="ebw-entry__tab-content">
                <TabPane tabId="1" className="ebw-entry__tab-pane">
                    <div className="ebw-entry__tab-desc">
                        <LoginEmail />
                    </div>
                </TabPane>

                <TabPane tabId="2" className="ebw-entry__tab-pane">
                    <div className="ebw-entry__tab-desc">
                        <LoginOtp />
                    </div>
                </TabPane>
            </TabContent>
        </div>
    );
}
export default NavTabs;